import { Box, Button, DialogActions, DialogContent, Icon, Paper, Typography } from "@mui/material"
import Icons from "../../../assets/js/Icons"
import { Cookies } from "react-cookie"

const cookies = new Cookies()
function ChatWarn({ handleClose }) {

  const handleClick = () => {
    const midnight = new Date();
    midnight.setHours(24, 0, 0, 0);

    cookies.set("dailyChatWarn", "dailyChatWarn", { path: "/", expires: midnight })
    handleClose()
  }

  return (
    <Paper>
      <DialogContent
        className="relative"
        sx={{
          ".MuiInputBase-root": { borderRadius: "6px" },
          textarea: { resize: "none" },
        }}
      >
        <Box sx={{ mb: 1, display: "grid", placeContent: "center" }}>
          <Icon
            sx={{
              fontSize: "100px",
              color: "primary.main",
              svg: { display: "block" },
            }}
          >
            <Icons.Alert />
          </Icon>
        </Box>
        <Typography fontSize={15} color="other.color1" textAlign="center">Please keep your conversation polite and respectful. Do not use any offensive language.</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center" }}>
        <Button
          color="primary"
          variant="contained"
          onClick={handleClick}
          sx={{
            minWidth: "150px",
            justifyContent: "center",
          }}
        >Okay
        </Button>
      </DialogActions>
    </Paper>
  )
}

export default ChatWarn